var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 152,
    viewBox: "0 0 50 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.5H49.5V147.514L25 151.493L0.5 147.514V18.5Z",
    fill: "white",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 0.5,
    width: 29,
    height: 18,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0227 66.1816L27.9424 66.1816L27.9424 70.1813C27.9424 71.8018 27.478 72.9987 26.6035 73.809C25.7971 74.5529 24.7054 74.9654 23.4889 74.9654C22.2723 74.9654 21.0987 74.5406 20.2922 73.7427C19.5275 72.9852 19.0214 71.8963 19.0214 70.1813L19.0214 66.1816L19.0227 66.1816ZM21.0305 70.1285C21.0305 71.0185 21.235 71.4703 21.6173 71.8558C22.0679 72.3076 22.6282 72.5605 23.4611 72.5605C24.2398 72.5605 24.814 72.3346 25.2645 71.9221C25.6873 71.5366 25.9334 71.0848 25.9334 70.1285L25.9334 68.5068L21.0292 68.5068L21.0292 70.1285L21.0305 70.1285Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0229 74.5508L27.9426 78.5774L27.9426 80.5036L19.0229 84.5303L19.0229 81.9927L20.3883 81.4342L20.3883 77.5536L19.0229 77.0085L19.0229 74.5508ZM22.246 78.2975L22.246 80.689L25.1006 79.5325L25.1006 79.4527L22.246 78.2963L22.246 78.2975Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4576 91.0962C25.7996 90.5254 26.3322 89.4352 26.3322 88.1597C26.3322 87.455 26.004 86.8437 25.4311 86.8437C24.8026 86.8437 24.7484 87.8405 24.6524 88.7833C24.5426 90.378 24.3243 92.8898 21.8937 92.8898C19.6398 92.8898 18.7514 91.0827 18.7514 88.9036C18.7514 86.7246 19.612 85.1434 20.4046 84.0937L22.03 85.3423C21.5934 85.9401 20.6229 87.3224 20.6229 88.8631C20.6229 89.9398 21.1012 90.5634 21.688 90.5634C22.3304 90.5634 22.4528 89.8195 22.5487 88.7035C22.7128 86.7639 22.9172 84.5173 25.3074 84.5173C27.5197 84.5173 28.2163 86.5232 28.2163 88.2113C28.2163 89.9913 27.6017 91.5725 27.1234 92.357L25.4563 91.095L25.4576 91.0962Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4576 102.071C25.7996 101.5 26.3322 100.41 26.3322 99.1343C26.3322 98.4296 26.004 97.8183 25.4311 97.8183C24.8026 97.8183 24.7484 98.8151 24.6524 99.7579C24.5426 101.353 24.3243 103.864 21.8937 103.864C19.6398 103.864 18.7514 102.057 18.7514 99.8783C18.7514 97.6992 19.612 96.118 20.4046 95.0684L22.03 96.3169C21.5934 96.9147 20.6229 98.2971 20.6229 99.8377C20.6229 100.914 21.1012 101.538 21.688 101.538C22.3304 101.538 22.4528 100.794 22.5487 99.6781C22.7128 97.7385 22.9172 95.4919 25.3074 95.4919C27.5197 95.4919 28.2163 97.4979 28.2163 99.1859C28.2163 100.966 27.6017 102.547 27.1234 103.332L25.4563 102.07L25.4576 102.071Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9426 103.732L27.9426 111.785L25.9348 111.785L25.9348 108.928L19.0229 108.928L19.0229 106.603L25.9348 106.603L25.9348 103.732L27.9426 103.732Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5674 126.335C19.6108 125.285 18.7501 123.718 18.7501 121.804C18.7501 118.894 20.8816 116.967 23.4901 116.967C26.0987 116.967 28.2163 118.906 28.2163 121.737C28.2163 123.332 27.5878 124.953 26.6868 126.07L25.1295 124.675C25.8122 123.865 26.2085 122.815 26.2085 122.031C26.2085 120.423 24.9654 119.386 23.4763 119.386C21.9871 119.386 20.744 120.45 20.744 122.097C20.744 123.107 21.3586 124.157 22.0969 124.927L20.5674 126.335Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5968 129.286L27.9436 132.701L27.9436 135.651L24.4062 131.971L19.0238 136.183L19.0238 133.299L22.8616 130.336L21.8368 129.286L19.0226 129.286L19.0226 126.947L27.9423 126.947L27.9423 129.286L24.5955 129.286L24.5968 129.286Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0229 111.82L19.0229 114.555L27.9426 116.458L27.9426 113.723L19.0229 111.82Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31 117.109L31 114.374L28.9354 113.934L28.9354 116.669L31 117.109Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0706,
    y: 28.7071,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "rotate(45 25.0706 28.7071)",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0701,
    y: 37.7091,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "rotate(45 34.0701 37.7091)",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.071,
    y: 37.7091,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "rotate(45 16.071 37.7091)",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0706,
    y: 46.7071,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "rotate(45 25.0706 46.7071)",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStick);
export default __webpack_public_path__ + "static/media/ic-stick.b86a874c07ddd4f7271f32e041ac9e76.svg";
export { ForwardRef as ReactComponent };